import { Assignment } from '@cco/model';
import { createAction, props, union } from '@ngrx/store';

export const TransitionAssignmentState = createAction(
  '[Assignment] TRANSITION_ASSIGNMENT_STATE',
  props<{ id: number; transitionId: number; reason: string }>(),
);
export const TransitionAssignmentStateSuccess = createAction(
  '[Assignment] TRANSITION_ASSIGNMENT_STATE_SUCCESS',
  props<{ assignment: Assignment }>(),
);
export const TransitionAssignmentStateFailure = createAction(
  '[Assignment] TRANSITION_ASSIGNMENT_STATE_FAILURE',
  props<{ error: any }>(),
);
export const UndoAssignmentStateTransition = createAction(
  '[Assignment] UNDO_ASSIGNMENT_STATE_TRANSITION',
  props<{ id: number; targetStateId: number; reason: string }>(),
);
export const UndoAssignmentStateTransitionSuccess = createAction(
  '[Assignment] UNDO_ASSIGNMENT_STATE_TRANSITION_SUCCESS',
  props<{ assignment: Assignment }>(),
);
export const UndoAssignmentStateTransitionFailure = createAction(
  '[Assignment] UNDO_ASSIGNMENT_STATE_TRANSITION_FAILURE',
  props<{ error: any }>(),
);
export const TransitionAssignmentStateToLoading = createAction(
  '[Assignment] TRANSITION_ASSIGNMENT_STATE_TO_LOADING',
  props<{ id: number; transitionId: number; reason: string; yardId: number }>(),
);
export const TransitionAssignmentStateToLoadingSuccess = createAction(
  '[Assignment] TRANSITION_ASSIGNMENT_STATE_TO_LOADING_SUCCESS',
  props<{ assignment: Assignment }>(),
);
export const TransitionAssignmentStateToLoadingFailure = createAction(
  '[Assignment] TRANSITION_ASSIGNMENT_STATE_TO_LOADING_FAILURE',
  props<{ error: any }>(),
);

export const AssignmentActions = union({
  TransitionAssignmentState,
  TransitionAssignmentStateSuccess,
  TransitionAssignmentStateFailure,
  UndoAssignmentStateTransition,
  UndoAssignmentStateTransitionSuccess,
  UndoAssignmentStateTransitionFailure,
  TransitionAssignmentStateToLoading,
  TransitionAssignmentStateToLoadingSuccess,
  TransitionAssignmentStateToLoadingFailure,
});
